import React from 'react';
import classNames from 'classnames';
import Input from '../Input/Input';
import PropTypes from 'prop-types';

const InputWithLabel = ({className, disabled, id, inputDivClassName, label, labelClassName, maxLength, min, name,  onChange, onClick, placeholder, type, value }) => {
    const divClassValue = classNames(
        'form-group',
        className
    );
    const labelClassValue = classNames(
        'control-label',
        "col-xs-12",
        labelClassName
    );
    const inputDivClassValue = classNames(
        inputDivClassName
    );
    return(
        <div className={divClassValue}>
            <label
                className={labelClassValue}
                htmlFor={id}>
                {label}
            </label>
            <div className={inputDivClassValue}>
                <Input
                    className="form-control"
                    disabled={disabled}
                    id={id}
                    min={min}
                    name={name}
                    maxLength={maxLength}
                    onChange={onChange}
                    onClick={onClick}
                    placeholder={placeholder}
                    type={type}
                    value={value} />
            </div>
        </div>
    );
};

InputWithLabel.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    inputDivClassName: PropTypes.string,
    label: PropTypes.string,
    labelClassName: PropTypes.string,
    maxLength: PropTypes.number,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool
    ])
};

export default InputWithLabel;


// WEBPACK FOOTER //
// ./src/components/base/InputWithLabel/InputWithLabel.js